const titleCase = (params) => {
	if (!params) { return; }
	return params
	  .toLowerCase()
	  .split(' ')
	  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
	  .join(' ');
};

export default {
	tracking(params = '') {
		return {
			// success
			SUCCESS_UPDATE_SERIAL_NUMBER: `Successfully updated ${titleCase(params)}.`,
			SUCCESS_CONNECT_TRACKING: `Successfully connected ${titleCase(params)}.`,
			SUCCESS_DISCONNECT_TRACKING: `Successfully disconnected ${titleCase(params)}.`,
			SUCCESS_DELETE_TRACKING: `Successfully deleted ${titleCase(params)}.`,

			// error
			ERROR_INVALID_SERIAL_NUMBER: 'Empty or invalid tracking serial number.',
			ERROR_UPDATE_SERIAL_NUMBER: 'Unable to update serial number.',
			ERROR_CONNECT_TRACKING: 'Unable to connect tracking.',
			ERROR_DISCONNECT_TRACKING: 'Unable to disconnect tracking.',
			ERROR_DELETE_TRACKING: 'Unable to delete serial number.'
		}
	},
	pet() {
		return {
			// error
			ERROR_GET_PET_LIST: 'Unable to get pet list.'
		}
	},
	bundles(params = '') {
		return {
			// success
			SUCCESS_ADD_PRODUCT_MSG: 'Product successfully added.',
			SUCCESS_DELETE_PRODUCT_TITLE: 'Successfully deleted.',
			SUCCESS_ACTIVATE_TITLE: 'Successfully activated!',
			SUCCESS_DEACTIVATE_TITLE: 'Successfully deactivated.',
			SUCCESS_ADD_BUNDLE: 'Successfully added.',
			SUCCESS_EDIT_BUNDLE: 'Successfully edited.',

			// success text
			SUCCESS_ACTIVATE_TEXT: `Successfully activated ${titleCase(params)}.`,
			SUCCESS_DEACTIVATE_TEXT: `Successfully deactivated ${titleCase(params)}.`,
			SUCCESS_DELETE_TEXT: `Successfully deleted ${titleCase(params)}.`,
			

			// error
			ERROR_ADD_PRODUCT_TITLE: 'Unable to add product.',
			ERROR_ADD_PRODUCT_MSG: 'Product already exists in the doggy pack.',
			ERROR_ACTIVATE_BUNDLE: 'Unable to reactivate doggy pack.',
			ERROR_DEACTIVATE_BUNDLE: 'Unable to deactivate doggy pack.',
			ERROR_GET_BUNDLE: 'Unable to get doggy pack.',
			ERROR_ADD_BUNDLE: 'Unable to add doggy pack.',
			ERROR_EDIT_BUNDLE: 'Unable to edit doggy pack.'
		}
	},
	brands(params = '') {
		return {
			// success
			SUCCESS_ADD_BRAND_MSG: 'Brand successfully added.',
			SUCCESS_DELETE_BRAND_TITLE: 'Successfully deleted.',
			SUCCESS_ACTIVATE_TITLE: 'Successfully activated!',
			SUCCESS_DEACTIVATE_TITLE: 'Successfully deactivated.',
			SUCCESS_ADD_BRAND: 'Successfully added.',
			SUCCESS_EDIT_BRAND: 'Successfully edited.',

			// success text
			SUCCESS_ACTIVATE_TEXT: `Successfully activated ${titleCase(params)}.`,
			SUCCESS_DEACTIVATE_TEXT: `Successfully deactivated ${titleCase(params)}.`,

			// error
			ERROR_ADD_BRAND_TITLE: 'Unable to add brand.',
			ERROR_ACTIVATE_BRAND: 'Unable to reactivate brand.',
			ERROR_DEACTIVATE_BRAND: 'Unable to deactivate brand.',
			ERROR_GET_BRAND: 'Unable to get brand.',
			ERROR_ADD_BRAND: 'Unable to add brand.',
			ERROR_EDIT_BRAND: 'Unable to edit brand.'
		}
	},
	product(params = '') {
		return {
			// success title
			SUCCESS_ACTIVATE_TITLE: 'Successfully activated.',
			SUCCESS_DEACTIVATE_TITLE: 'Successfully deactivated.',
			SUCCESS_PRODUCT_ADD: 'Product successfully added.',
			SUCCESS_PRODUCT_EDIT: 'Product successfully edited.',
			SUCCESS_DELETE_PRODUCT_TITLE: 'Successfully deleted.',
			
			// success text
			SUCCESS_ACTIVATE_TEXT: `Successfully activated ${titleCase(params)}.`,
			SUCCESS_DEACTIVATE_TEXT: `Successfully deactivated ${titleCase(params)}.`,
			SUCCESS_DELETE_TEXT: `Successfully deleted ${titleCase(params)}.`,
			// error
			ERROR_ACTIVATE_PRODUCT: 'Unable to reactivate product.',
			ERROR_DEACTIVATE_PRODUCT: 'Unable to deactivate product.',
			ERROR_PRODUCT_ADD: 'Unable to add product.',
			ERROR_PRODUCT_EDIT: 'Unable to edit product.',
			ERROR_PRODUCT_FETCH: 'Unable to fetch Product.'
		}
	},
	post() {
		return {
			ERROR_GET_POST: 'Unable to get post.',
			ERROR_DELETE_POST: 'Unable to delete the post.'
		}
	},
	comment() {
		return {
			ERROR_GET_COMMENT: 'Unable to get comment.',
			ERROR_DELETE_COMMENT: 'Unable to delete the comment.'
		}
	},
	reportContent(params = '') {
		return {
			SUCCESS_REPORT_CONTENT: `Reported Content has been ${params.toLowerCase()} for deletion.`,
			ERROR_REPORT_CONTENT: `Unable to ${params.toLowerCase()} content for deletion.`
		}
	},
	auditTrail() {
		return {
			// error
			ERROR_GET_AUDIT_TRAIL_LIST: 'Unable to get audit trail list.',
			ERROR_GET_AUDIT_TRAIL_ACTION: 'Unable to get audit trail action.',
			ERROR_GET_AUDIT_TRAIL_CHANGES: 'Unable to get audit trail changes.'
		}
	},
	subscription() {
		return {
			// success
			SUCCESS_CANCEL_SUBSCRIPTION: 'Subscription successfully cancelled.',
			SUCCESS_DELETE_SUBSCRIPTION: 'Subscription successfully deleted.',
			// error
			ERROR_GET_SUBSCRIPTION_DETAILS: 'Unable to get subscription details.',

			ERROR_GET_SUBSCRIPTION_LIST: 'Unable to get subscription list.',
			ERROR_CANCEL_SUBSCRIPTION: 'Unable to cancel subscription.',
			ERROR_DELETE_SUBSCRIPTION: 'Unable to delete subscription.',
			ERROR_GET_SUBSCRIPTION_PERIOD_LIST: 'Unable to get subscription period list.'
		}
	},
	breed() {
		return {
			// success
			SUCCESS_DELETE_BREED_TITLE: 'Successfully deleted.',

			// error
			ERROR_ADD_BREED_TITLE: 'Unable to add breed.',
			ERROR_ADD_BREED_MSG: 'Breed with the same age already exists.',
			ERROR_GET_BREED_TITLE: 'Unable to get breeds.'
		}
	},
	club(params = '') {
		return {
			// success
			SUCCESS_MAKE_ADMIN: `Successfully appointed ${titleCase(params)} as an admin.`,
			SUCCESS_REMOVE_ADMIN: `Successfully removed ${titleCase(params)} as an admin.`,
			SUCCESS_APPROVED_ADMIN: `Successfully approved ${titleCase(params)} as an admin.`,
			SUCCESS_DISAPPROVED_ADMIN: `Successfully disapproved ${titleCase(params)} as an admin.`,

			// error
			ERROR_MAKE_ADMIN: 'Unable to appoint as an admin.',
			ERROR_REMOVE_ADMIN: 'Unable to remove as an admin.',
			ERROR_APPROVE_ADMIN: 'Unable to approved as an admin.',
			ERROR_DISAPPROVE_ADMIN: 'Unable to disapproved as an admin.',
		}
	},
	treatment() {
		return {
			// error
			ERROR_GET_TREATMENT_FREQUENCY_LIST: `Unable to get treatment frequency list.`,
			ERROR_GET_TREATMENT_LIST: 'Unable to get treatment list.',
		}
	},
	order(params = '') {
		return {
			// Success
			SUCCESS_ORDER_TRACKING: `Successfully ${params.toLowerCase()} tracking number.`,
			SUCCESS_DISAPPROVE_CANCELLATION: 'Cancellation Request successfully disapproved.',
			SUCCESS_APPROVE_CANCELLATION: 'Cancellation Request successfully approved.',
			SUCCESS_LATITUDE_PAY_REFUND: 'LatitudePay Refund Request successfully approved.',
			SUCCESS_MARKED_ORDER_AS_DELIVERED: 'Successfully Marked Order as Delivered.',
			SUCCESS_DELETE: 'Successfully Delete Pending Dog Order.',
			
			// Errors
			ERROR_ORDER_TRACKING: `Unable to add or update tracking number.`,
			ERROR_DISAPPROVE_CANCELLATION: 'Unable to disapprove cancellation request.',
			ERROR_APPROVE_CANCELLATION: 'Unable to approve cancellation request.',
			ERROR_MARK_ORDER_AS_DELIVERED: 'Unable to mark order as delivered.',
			ERROR_MARK_ORDER_AS_REFUNDED: 'Unable to mark order as Refunded.',
			ERROR_MARK_ORDER_AS_PICKED_UP: 'Unable to mark order as Picked Up.'
		}
	},
	notification() {
		return {
			// success
			SUCCESS_NOTIFICATION_SEND: 'Successfully sent a notification.',
			SUCCESS_DELETE_NOTIFICATION: 'Successfully deleted notification.',
			// error
			ERROR_GET_NOTIFICATION_LIST: 'Unable to get notification list.',
			ERROR_NOTIFICATION_SEND: 'Unable to send notification.',
			ERROR_DELETE_NOTIFICATION: 'Unable to delete notification.'
		}
	},
	user() {
		return {
			ERROR_UPDATE_USER: 'Unable to update user details.',
			SUCCESS_REMOVED_PROFILE: 'Succesfully removed walker or sitter profile.',
			SUCCESS_CREATED_PROFILE: 'Succesfully created walker or sitter profile.',
			SUCCESS_UPDATE_PROFILE: 'Profile Successfully Updated.',
			SUCCESS_UPDATE_BREED: 'Preferred Breed Successfully Updated.',
			SUCCESS_UPDATE_SCHEDULE: 'Schedule Successfully Updated.'
		}
	},

	damSire() {
		return {
			SUCCESS_ADD_DAM_SIRE: 'Successfully added a dam/sire.',
			ERROR_ADD_DAM_SIRE: 'Failed to add a dam/sire.',

			ERROR_GET_DAM_SIRE: 'Unable to get dam/sire details.',

			SUCCESS_UPDATE_DAM_SIRE: 'Successfully updated dam/sire details.',
			ERROR_UPDATE_DAM_SIRE: 'Failed to update dam/sire details.',
		}
	},
	damSireDocument() {
		return {
			SUCCESS_ADD_DAM_SIRE_DOCUMENT: 'Successfully uploaded document.',
			ERROR_ADD_DAM_SIRE_DOCUMENT: 'Failed to upload document.',

			SUCCESS_EDIT_DAM_SIRE_DOCUMENT: 'Successfully updated document.',
			ERROR_EDIT_DAM_SIRE_DOCUMENT: 'Failed to update document.',

			SUCCESS_DELETE_DAM_SIRE_DOCUMENT: 'Successfully deleted document.',
			ERROR_DELETE_DAM_SIRE_DOCUMENT: 'Failed to delete document.',

			ERROR_GET_DAM_SIRE_DOCUMENTS_LIST: 'Unable to get documents list.',
		}
	},
	mating() {
		return {
			SUCCESS_ADD_MATING: 'Successfully added mating details.',
			ERROR_ADD_MATING: 'Failed to add a mating details.',

			ERROR_GET_DAM_SIRE_LIST: 'Unable to get dam/sire list.',
			ERROR_GET_MATING_DETAILS: 'Unable to get mating details.',

			SUCCESS_UPDATE_MATING: 'Successfully updated mating details.',
			ERROR_UPDATE_MATING: 'Failed to update mating details.',
		}
	},
	ovulationGestation(){
		return {
			SUCCESS_ADD_OVULATION_GESTATION: 'Successfully added ovulation and gestation details.',
			ERROR_ADD_OVULATION_GESTATION: 'Failed to ovulation and gestation details.',
		}
	},
	litters(){
		return {
			SUCCESS_ADD_LITTER: 'Successfully added all litters.',
			SUCCESS_UPDATE_LITTER: 'Successfully updated puppy details.',
			ERROR_ADD_LITTER: 'Failed to add all litters.',

			ERROR_GET_LITTER_LIST:  'Unable to get transactions.',
		}
	},

	noteReminder() {
		return {
			SUCCESS_ADD_NOTE_REMINDER: 'Note/reminder added successfully.',
			ERROR_ADD_NOTE_REMINDER: 'Failed to add note/reminder.',
		}
		
	}
};
  